import React from 'react'

import { TextField } from 'components/ds'
import { FilterComponentProps, FilterOperatorOption } from 'types/filter-page'
import { FilterOperatorSelector } from '../../filter-operator-selector'
import { useKeyPress } from 'hooks/use-key-press'

const TextForm = ({
  label,
  value,
  onChange,
  operator = 'contains',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  const allFilterOperators: FilterOperatorOption[] = [
    {
      value: 'contains',
      component: (
        <TextField.Root
          value={value || ''}
          onChange={e => onChange(e.target.value, operator)}
          onKeyDown={handleKeyDown}
          type="text"
          placeholder={label}
          autoFocus
        />
      ),
    },
  ]

  return (
    <FilterOperatorSelector
      operator={operator}
      onChange={onChange}
      operators={allFilterOperators}
    />
  )
}

export default TextForm
